// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessageEditFormEditor-modulechatroomMessageEditFormEditor___OBwW ChatroomInputFormFields-moduleeditorZone__YiKqg";
var _2 = "ChatroomMessageEditFormEditor-moduledragging__XPpTy ChatroomInputFormFields-moduleeditorZoneDragging__z5M6b";
var _3 = "ChatroomMessageEditFormEditor-moduleover__DZzdB ChatroomInputFormFields-moduleeditorZoneOver__EJNas";
var _4 = "ChatroomMessageEditFormEditor-moduletext__IYdP8 ChatroomInputFormFields-moduleeditorZoneText__DNVG3";
export { _1 as "chatroomMessageEditFormEditor", _2 as "dragging", _3 as "over", _4 as "text" }
